import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useAddEntityToSeason = () => {
  const { sport, organizationId, seasonId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();
  const { formatMessage } = useIntl();
  const notification = useNotification();

  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    mutationFn: async (entityId: string) =>
      await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities`, {
        method: "POST",
        body: {
          status: "ACTIVE",
          entityId,
        },
      }),
    onSuccess: async () => {
      notification.success({
        message: formatMessage({ id: "seasonEntity.add.success" }),
        placement: "bottomRight",
      });

      await queryClient.invalidateQueries({ queryKey: ["seasonEntities", sport, organizationId, seasonId] });
    },
  });
};
